import { ComponentPropsWithRef, forwardRef } from "react";

import { Ds } from "@accurx/design";
import { StyledDropdownMenuItem } from "@accurx/navigation";
import styled from "styled-components";

export const DropdownExternalLink = forwardRef<
    HTMLAnchorElement,
    ComponentPropsWithRef<"a">
>(({ children, ...props }, forwardedRef) => {
    return (
        <StyledDropdownMenuItem asChild>
            <StyledLink
                ref={forwardedRef}
                href={props.href}
                target="_blank"
                rel="noopener noreferrer"
                {...props}
            >
                <Ds.Flex gap="1">{children}</Ds.Flex>
                <Ds.Icon name="OpenWindow" size="small" color="metal" />
            </StyledLink>
        </StyledDropdownMenuItem>
    );
});

export const StyledLink = styled.a`
    display: flex;
    justify-content: space-between;
    align-content: start;
    width: 100%;
`;
